<template>
  <div class="is-flex pagination">
    <button class="button is-borderless" @click="firstPage" :disabled="page === 1">First</button>
    <button class="button is-borderless" @click="prevPage" :disabled="page === 1">Prev</button>
    <div class="is-expanded has-text-centered">Page {{ page }} of {{ totalPages }}</div>
    <button class="button is-borderless" @click="nextPage" :disabled="page === totalPages">Next</button>
    <button class="button is-borderless" @click="lastPage" :disabled="page === totalPages">Last</button>
  </div>
</template>
<script>
export default {
  props: ["module"],
  computed: {
    page() {
      let component = this;
      return component.$store.getters[`${component.module}/page`];
    },
    totalPages() {
      let component = this;
      return component.$store.getters[`${component.module}/totalPages`];
    }
  },
  methods: {
    nextPage() {
      let component = this;
      component.$store.commit(`${component.module}/page`, component.page + 1);
      component.$store.dispatch(`${component.module}/index`);
    },
    prevPage() {
      let component = this;
      component.$store.commit(`${component.module}/page`, component.page - 1);
      component.$store.dispatch(`${component.module}/index`);
    },
    firstPage() {
      let component = this;
      component.$store.commit(`${component.module}/page`, 1);
      component.$store.dispatch(`${component.module}/index`);
    },
    lastPage() {
      let component = this;
      component.$store.commit(`${component.module}/page`, component.totalPages);
      component.$store.dispatch(`${component.module}/index`);
    }
  }
};
</script>
<style lang="scss" scoped>
.button {
  background: transparent;
}
</style>